import mock from '@/fake-db/mock.js'

const data = {
  dispatchedOrders: [
    {
      name: 'Cinar Knowles',
      usersLiked: [
        {
          name: 'Vennie Mostowy',
          img: require('@/assets/images/portrait/small/avatar-s-5.jpg')
        },
      ],
      location: 'Anniston, Alabama',
      startDate: '26/07/2018',
    },
    {
      name: 'Britany Ryder',
      usersLiked: [
       {
          name: 'Lilian Nenez',
          img: require('@/assets/images/portrait/small/avatar-s-2.jpg')
        },      
      ],
      location: 'Cordova, Alaska',
      startDate: '26/07/2018',
    },
    {
      name: 'Kishan Ashton',
      usersLiked: [
        {
          name: 'Jeffrey Gerondale',
          img: require('@/assets/images/portrait/small/avatar-s-9.jpg')
        }
      ],
      location: 'Florence, Alabama',
      startDate: '26/07/2018',
    },
    {
      name: 'Anabella Elliott',
      usersLiked: [
        {
          name: 'Elicia Rieske',
          img: require('@/assets/images/portrait/small/avatar-s-7.jpg')
        }
      ],
      location: 'Clifton, Arizona',
      startDate: '26/07/2018',
    }
  ]
}


mock.onGet('/api/table/dispatched-orders').reply(() => {
  return [200, data.dispatchedOrders]
})
